// Accessible pill-style toggle — used in place of Shadcn Switch where radix-ui is not installed.

import type { JSX } from "react";

interface Props { label: string; checked: boolean; onChange: (v: boolean) => void; }

export function SwitchToggle({ label, checked, onChange }: Props): JSX.Element {
  return (
    <label className="flex items-center gap-3 text-sm text-slate-700 cursor-pointer select-none">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-navy-500 focus:ring-offset-1 ${checked ? "bg-navy-700" : "bg-slate-200"}`}
      >
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${checked ? "translate-x-4" : "translate-x-0.5"}`} />
      </button>
      {label}
    </label>
  );
}
